// extracted by mini-css-extract-plugin
module.exports = {"alternativeText":"_3biD9lb","suggestedTerm":"_2f22PFS"};